import { Stack, Typography, IconButton } from '@mui/material'
import { styled } from '@mui/system'
import * as React from 'react'
import { useIntl } from 'react-intl'
import ItemList from '../comps/portrait/ItemList'
import ItemPeopleList from '../comps/portrait/ItemPeopleList'
import Slide from '@mui/material/Slide';
import Article from './article'
import _ from 'underscore'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import useDisplayArticle from '../tools/useDisplayArticle'
import SearchContext from '../tools/context/SearchContext'
import Image from "../images/background.jpg"
import PreviewDiv from "../comps/portrait/PreviewDiv"

const RootDiv = styled(Stack)({
  position: "relative",
  overflow: "auto",
  height: "calc(100vh - 70px)",
  padding: "48px 0",
  scrollBehavior: "smooth",
  '&::-webkit-scrollbar': {
    display: "none",
  },
})

const ItemSort = styled("div")({
  position: "sticky",
  top: "0px",
  left: "34px",
  margin: "0 0 0 34px"
})

const TypoSort = styled(Typography)({
  display: "inline-block",
  marginRight: "16px",
  fontWeight: "700",
})

const StyledLi = styled('div')({
  width: "105px",
  display: "inline-block",
  marginRight: "16px",
  borderBottom: "1px solid #8a8a87",
  listStyleType: "none",
  '&:hover, &.Mui-focusVisible': {
    borderBottom: "1px solid black",
  }
})

const StyledLink = styled('div')({
  color: "#4b4b4b",
  textDecoration: "none",
  '&:hover, &.Mui-focusVisible': {
    cursor: "pointer",
    color: "black",
  }
})

const ItemLists = styled(Stack)({
  height: "100%",
  width: "max-content",
  margin: "0 0 0 34px",
})

const RootDivTransition = styled('div')({
	width: "100vw",
  zIndex: '10000',
  height: "calc(100vh - 70px)",
  flexDirection: "row",
  position: "absolute",
  overflow: "auto",
  top: "0px",
  left: "0px",
  backgroundColor: "white"
})

const ButtonLeft = styled(IconButton)({
  position: "absolute",
  backgroundColor: "black",
  fontSize: "40px",
  zIndex: '9000',
  opacity: '0.5',
  top: "50%",
  left: '20px',
  '&:hover': {
    backgroundColor: 'grey',
  },
})

const ButtonRight = styled(IconButton)({
  position: "absolute",
  backgroundColor: "black",
  zIndex: '9000',
  opacity: '0.5',
  top: "50%",
  right: '20px',
  '&:hover': {
    backgroundColor: 'grey',
  },
})

const ButtonPreview = styled(Typography)({
	textAlign: 'center',
	margin: "auto 0",
	display: 'inline-block',
	padding: "10px 3px 0 3px",
	fontSize: "22px",
	cursor: 'pointer',
	'&:hover': {
    textDecoration: "underline",
  },
})

export default function Portrait ({pageContext}) {
  const data = pageContext.data;
  const intl = useIntl()
  const SearchContextObject = React.useContext(SearchContext)
  const ref = React.useRef();
  const refLists = React.useRef();
  const [filter, setFilter] = React.useState(0);
	const [anchor, setAnchor] = React.useState(null);
  const [article, handleClickItem, handleCloseItem] = useDisplayArticle(data, "portrait");

  React.useEffect(() => {
    SearchContextObject.setHandler(handleClickItem);
    return (() => {
      SearchContextObject.setHandler(null);
    })
  }, [])

  const handleClickfilter = (index, target) => {
    setFilter(index);
		setAnchor(target);
  }

  const handleScroll = (e, value) => {
    e.preventDefault();
    let offset = refLists.current.getBoundingClientRect();
    let newPosition = Math.abs(offset.x) + value;
    ref.current.scrollLeft = newPosition;
  }

  const handleScrollThrottle = _.throttle(handleScroll, 300);

  const handleOverPreview = (node) => {
    if (node){
      node.scrollIntoView({inline : "start"})
    }
  }

  const sorts = React.useRef([
    {
      id: "perName",
      check: (people, item) => (people.lastname.toUpperCase()[0] === item),
      lists: Array.from(Array(26)).map((e, i) => String.fromCharCode(65 + i)),
			listPreviews: Array.from(Array(26)).map((e, i) => String.fromCharCode(65 + i)).reduce((array, key) => {
				return {...array, [key]: React.createRef()}
			}, {}),
			createButton: (key, value) => {
				return(
					<ButtonPreview
						key={key}
            onMouseEnter={() => (handleOverPreview(value.current))}
						sx={{
							color: (!Boolean(value.current) ? "#6b6a62" : "black")
						}}
					>
						{key}
					</ButtonPreview>
				)
			}
    },
    {
      id: "perDate",
      check: (people, item) => ((Math.floor(people.date_start.substring(0, 4) / 10)) === (Number(item) / 10)),
      lists: Array.from(Array((2020-1800) / 10)).map((_, i) => (1800 + (i * 10)) + ""),
			listPreviews: Array.from(Array((2020-1800) / 10)).map((_, i) => (1800 + (i * 10)) + "").reduce((array, key) => {
				return {...array, [key]: React.createRef()}
			}, {}),
			createButton: (key, value) => {
				return(
					<ButtonPreview
						key={key}
            onMouseEnter={() => (handleOverPreview(value.current))}
						sx={{
							fontSize: (key % 100 === 0) ? "22px" : "16px",
							color: (!Boolean(value.current) ? "#6b6a62" : "black")
						}}
					>
						{(key % 100 === 0) ?  key : key.substring(2, 4)}
					</ButtonPreview>
				)
			}
    },
    {
      id: "perType",
      check: (people, item) => (people.portrait_category.some(cat => (cat.translations.find(translat => translat.lang === intl.locale).title === item))),
      lists: data.swapi.allPortraitCategory.map((cat) => ((cat.translations.find((translation) => (translation.lang === intl.locale))).title)),
			listPreviews: data.swapi.allPortraitCategory.map((cat) => ((cat.translations.find((translation) => (translation.lang === intl.locale))).title)).reduce((array, key) => {
				return {...array, [key]: React.createRef()}
			}, {}),
			createButton: (key, value) => {
				return(
					<ButtonPreview
						key={key}
            onMouseEnter={() => (handleOverPreview(value.current))}
						sx={{
							color: (!Boolean(value.current) ? "#6b6a62" : "black")
						}}
					>
						{key}
					</ButtonPreview>)
			}
    },
  ]);

  return (
    <>
      <img
        src={Image}
        alt="background"
        quality={100}
        style={{
          height: "100%",
          position: 'absolute',
          bottom: '0px',
          left: '0px',
        }}
      />
      <ButtonLeft onClick={(e) => handleScrollThrottle(e, -1000)} aria-hidden={(article.open) ? true : false} aria-label={intl.formatMessage({ id: "leftArrowPortrait" })}>
        <ArrowBackIosIcon sx={{fontSize: "30px", color: "white", opacity: "1"}}/>
      </ButtonLeft>
      <ButtonRight onClick={(e) => handleScrollThrottle(e, 1000)} aria-hidden={(article.open) ? true : false} aria-label={intl.formatMessage({ id: "rightArrowPortrait" })}>
        <ArrowForwardIosIcon sx={{fontSize: "30px", color: "white", opacity: "1"}} />
      </ButtonRight>
      <RootDiv ref={ref} direction="column">
        <ItemSort>
          <TypoSort>
            {intl.formatMessage({ id: "sort" })}
          </TypoSort>
          {sorts.current.map((sort, i) => (
            <StyledLi key={sort.id + i}>
              <StyledLink onClick={(e) => handleClickfilter(i, e.currentTarget)}>
                {intl.formatMessage({ id: sort.id })}
              </StyledLink>
            </StyledLi>
          ))}
        </ItemSort>
        <ItemLists ref={refLists} direction="row" justifyContent="flex-start" alignItems="center">
          {sorts.current[filter].lists.map((item, i) => {
            let allPeople = data.swapi.allBricks.filter((brick) => (brick.type === "portrait")).filter((people) => (sorts.current[filter].check(people, item)))
            return (
              (!allPeople.length)
              ?
              null
              : 
              <React.Fragment key={item + i + filter}>
                <ItemList content={item} ref={sorts.current[filter].listPreviews[item]}/>
                <ItemPeopleList peoples={allPeople} handleClick={handleClickItem}/>
              </React.Fragment>
            )
          })}
        </ItemLists>
        <PreviewDiv anchor={anchor} listRef={{...sorts.current[filter].listPreviews}} createButton={sorts.current[filter].createButton}/>
      </RootDiv>
      <Slide direction="up" timeout={1000} easing={{enter: "cubic-bezier(0.33, 1, 0.68, 1)",exit: "linear"}} in={article.open} mountOnEnter unmountOnExit>
        <RootDivTransition>
          <Article article={article.event} onClose={handleCloseItem} handleClickItemLink={handleClickItem} inPortrait/>
        </RootDivTransition>
      </Slide>
    </>
  )
}